import * as feEvents from '@dazn/fe-events';

interface NotificationParams {
    itemName: feEvents.NotificationNameFragment;
}

const triggerNotificationImpressionEvent = ({ itemName }: NotificationParams): void => {
    feEvents.triggerNotificationImpressionEvent({
        notification: {
            itemType: 'notification',
            itemName,
        },
    });
};

export { triggerNotificationImpressionEvent }